// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7883a51b","295":"a9906464","312":"9af800b0","455":"91b74714"}[chunkId] + ".chunk.js";
};